import { render } from "./it-assets.vue?vue&type=template&id=e4a5369c"
import script from "./it-assets.vue?vue&type=script&lang=js"
export * from "./it-assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__